module.exports = __webpack_public_path__ + "assets/events_transportation_plain.7d24f7ab.svg";